module.exports = __webpack_public_path__ + "static/media/home-text.9da8ef71.png";